import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

import './InputWithIcon.scss';

export default class InputWithIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showPassword': false,
      'focus': false,
      'showItem': false,
    };
    this.ref = createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutSide);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutSide = event => {
    if (this.ref.current && !this.ref.current.contains(event.target)) {
      return this.setState({ 'showItem': false });
    }
    return;
  }

  handleShowPassword = () => this.setState({ 'showPassword': !this.state.showPassword });

  handleFocus = () => {
    const { onFocus } = this.props;

    if (onFocus) {
      onFocus();
    }
    return this.setState({ 'focus': true, 'showItem': true });
  }

  handleBlur = () => this.setState({ 'focus': false });

  handleShowIcon = () => {
    const { showPassword } = this.state;
    const { type, handleClearValue } = this.props;

    switch (type) {
      case 'password':
        return <span id="btn-show-password" className={`icon click far fa-eye${!showPassword ? '-slash' : ''}`} onClick={this.handleShowPassword} />;
      case 'clear':
        return <span id="btn-clear-value" className="icon click fas fa-times" onClick={handleClearValue} />;
      default:
        return null;
    }
  }

  render() {
    const { showPassword, focus, showItem } = this.state;
    const {
      value,
      icon,
      placeholder,
      type,
      onChange,
      onKeyPress,
      warning,
      warningText,
      template,
      onClick,
      disabled,
      id,
      maxLength,
      showAutoFill,
      dataAutoFill,
      alignIconRight,
      error,
    } = this.props;

    return (
      <div className={`InputWithIcon${template ? ` template-${template}` : ''}`}>
        <div className={`group-input${warning ? ' warning' : ''}${focus ? ' focus' : ''}${alignIconRight ? ' align-right' : ''}${error ? ' error' : ''}${disabled ? ' disabled' : ''}`}>
          {!alignIconRight && icon && <span className={`icon ${icon}`} />}
          <Input
            id={id}
            placeholder={placeholder}
            value={value}
            type={type && showPassword ? 'text' : type && type !== 'clear' ? type : 'text'}
            onChange={event => onChange(event)}
            onKeyPress={onKeyPress}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onClick={onClick}
            disabled={disabled}
            maxLength={maxLength}
            autoComplete="off"
          />
          {alignIconRight && icon ? <span className={`icon ${icon}`} /> : this.handleShowIcon()}
        </div>
        {
          showAutoFill && showItem && dataAutoFill && dataAutoFill.length ?
            <div className="group-auto-fill" ref={this.ref}>
              <div className="box-autofill">
                {dataAutoFill}
              </div>
            </div>
            : null
        }
        {
          warning && warningText ?
            <div className="warning-text" id={`${id}-warning-text`}>{warningText}</div>
            : null
        }
      </div>
    );
  }
}

InputWithIcon.propTypes = {
  'id': PropTypes.string,
  'value': PropTypes.any,
  'icon': PropTypes.string,
  'placeholder': PropTypes.string,
  'type': PropTypes.string,
  'onChange': PropTypes.func.isRequired,
  'onKeyPress': PropTypes.func,
  'warning': PropTypes.bool,
  'warningText': PropTypes.string,
  'onFocus': PropTypes.func,
  'template': PropTypes.string,
  'handleClearValue': PropTypes.func,
  'onClick': PropTypes.func,
  'disabled': PropTypes.bool,
  'maxLength': PropTypes.string,
  'showAutoFill': PropTypes.bool,
  'dataAutoFill': PropTypes.any,
  'alignIconRight': PropTypes.bool,
  'error': PropTypes.bool,
  'autoComplete': PropTypes.string,
};
